<div class="horizontal-tree-container inline-flex h-full !overflow-x-auto">
  @for (level of levels(); track level) {
    <div
      class="tree-level relative flex flex-col gap-2xl"
      (scroll)="onScroll($event)">
      @for (node of nodesPerLevel()[level]; track node.id; let index = $index) {
        <div class="relative">
          <!-- Vertical line for child nodes -->
          @if (node.isChild && index !== node.parentIndex) {
            @let parentIndex = node.parentIndex ?? 0;
            @let heightCalculation =
              (node.index - parentIndex) *
              5.5 *
              (node.index < parentIndex ? -1 : 1);

            <div
              #verticalLine
              class="vertical-line"
              [class.active]="node.isSelected || isNoneSelectedAtLevel()[level]"
              [style.height]="`calc(${heightCalculation}rem)`"
              [style.bottom]="node.index > parentIndex ? '2rem' : ''"
              [style.top]="node.index < parentIndex ? '2rem' : ''"
              [attr.data-none-selected]="
                level > 1 && isNoneSelectedAtLevel()[level]
              "
              [attr.data-node-id]="node.id"
              [attr.data-parent-id]="node.parentId"
              [attr.data-child-index]="index"></div>
          }

          <lib-horizontal-tree-card
            #treeCard
            [node]="node"
            (selectedCard)="onCardClick($event)"
            [isNoneSelected]="isNoneSelectedAtLevel()[level]"
            [showTitle]="showNodeTitle()"
            [attr.data-node-id]="node.id" />
        </div>
      }

      @if (isLoadingAtLevel()[level]) {
        <ng-container [ngTemplateOutlet]="loadingTemplate" />
      } @else if (canLoadMoreAtLevel()?.(level) ?? false) {
        <div class="flex justify-center">
          <button
            type="button"
            class="flex items-center gap-sm py-sm px-lg cursor-pointer"
            (click)="onLoadMore(level)">
            <svg
              width="20"
              height="20"
              class="size-5 text-primary-600"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.4087 4.23333C11.6837 4.01667 10.8837 3.875 10.0004 3.875C6.00872 3.875 2.77539 7.10833 2.77539 11.1C2.77539 15.1 6.00872 18.3333 10.0004 18.3333C13.9921 18.3333 17.2254 15.1 17.2254 11.1083C17.2254 9.625 16.7754 8.24167 16.0087 7.09167"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M13.4415 4.43268L11.0332 1.66602"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M13.4411 4.43359L10.6328 6.48359"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>

            <span class="text-sm text-primary-600 font-medium">
              {{ translations().loadMoreButtonLabel }}
            </span>
          </button>
        </div>
      }
    </div>
  } @empty {
    @if (isLoadingAtLevel()[0]) {
      <ng-container [ngTemplateOutlet]="loadingTemplate" />
    }
  }
</div>

<ng-template #loadingTemplate>
  <div class="flex h-full w-card justify-center items-center py-sm px-4xl">
    <lib-loader size="lg" />
  </div>
</ng-template>
